import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { SortDirection, SnackBarMessageType } from "../../shared/contentTypes";
import { CoreLogService } from "../../services/log.service";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { ActivatedRoute } from "@angular/router";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { TermService } from "./term.service";
import { Subscription } from "rxjs";
import { ImpressumTermViewModel } from "../../shared/models/impressum.model";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { NavigationTitleViewModel } from "../../shared/models";
import { EMenuService } from "../../services/emenu.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { MatTabChangeEvent } from "@angular/material";
import { fromEvent } from "rxjs/internal/observable/fromEvent";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { MaterialTabHelperService } from "../../services/materialTabHelper.service";

@Component({
  selector: "app-term",
  templateUrl: "./term.component.html",
  styleUrls: ["./term.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermComponent implements OnInit, OnDestroy {
  private pagingHelper: PagingHelper = new PagingHelper();
  private sortOption: SortOption[] = [];

  public impressumTermViewModel: ImpressumTermViewModel[] = [];
  public pageTitle: NavigationTitleViewModel = new NavigationTitleViewModel();

  public isEMenu: boolean;
  public currentTermIndex = 0;
  public initialTermID: number | null = null;

  private langSubscriber: Subscription;
  private termChangesSubscriber: Subscription;
  private impressumChangesSubscriber: Subscription;
  private routeParamSubscriber: Subscription;
  private resizeSubscription: Subscription;

  constructor(private _termService: TermService,
    private _routerHelperService: RouterHelperService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _activatedRoute: ActivatedRoute,
    private _snackBarService: SnackBarService,
    private _internationalisationService: InternationalisationService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _materialTabHelperService: MaterialTabHelperService,
    private _eMenuService: EMenuService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("termComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.isEMenu = me._eMenuService.isActive;

    /**
     * Set the title of the page by title Data in route data
     * This data has been set in RouterHelperService by each navigation Enh Evnt
     */
    me.pageTitle = me._activatedRoute.snapshot.data["pageTitle"];
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["id"]) {
      me.initialTermID = routeTargetData["id"];
    } else {
      me.initialTermID = +(me._activatedRoute.snapshot.paramMap.get("id"));
    }
    if (!me.routeParamSubscriber) {
      me.routeParamSubscriber = me._activatedRoute.params.subscribe(params => {
        me.initialTermID = +(params['id']);
        me.ReloadDataAndRender();
      });
    }
    me.langSubscriber = this._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
      me.ReloadDataAndRender();
    });

    // reload page data if Impressum has been changed in storage.
    me.impressumChangesSubscriber = me._termService.ImpressumObserveChanges.subscribe((changed) => {
      me.ReloadDataAndRender();
    });

    me.sortOption.push(me.pagingHelper.createSortOption("sortNumber", SortDirection.ASC));
    // reload Impressum data data if data has been changed in storage.
    me.termChangesSubscriber = me._termService.TermObserveChanges.subscribe((changed) => {
      me.ReloadDataAndRender();
    });

    me.ReloadDataAndRender();
    me.PushChanges();

    // Resize Event

    //me.resizeSubscription = fromEvent(window, "resize").pipe(debounceTime(100)).subscribe((event) => {
    //me.sizeTerms();
    //});
  }


  ngAfterViewInit(): void {
    const me = this;
    setTimeout(() => {
      me.centerHeaderTitle();
    }, 500);
  }

  /** get Impressum data from storage
 */
  private ReloadDataAndRender(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._termService.GetImpressumTermViewModel().then(impressumTerm => {
      me.impressumTermViewModel = [];
      me.impressumTermViewModel.push(...impressumTerm.sort(me.pagingHelper.fieldSorter(me.sortOption)));
      if (me.initialTermID) {
        me.currentTermIndex = me.impressumTermViewModel.findIndex(term => term.id === me.initialTermID);
        me.initialTermID = null;
      }
      me.PushChanges();
      //me.sizeTerms();
      me._overlaySpinnerService.HideLayoutSpinner();
    })
      .catch(e => {
        me._coreLogService.error("termComponent.ReloadDataAndRender", "GetImpressumTermViewModel", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(82);
      });
  }

  private centerHeaderTitle() {
    const me = this;
    me._materialTabHelperService.TabHeaderTranslateAnimationWithIndex(me.currentTermIndex);
    me.PushChanges();
  }

  public headerTabFocusChange(event: MatTabChangeEvent) {
    const me = this;
    me._materialTabHelperService.TabHeaderTranslateAnimation(event);
    //me.sizeTerms();
  }

  public swipeRightHandler() {
    const me = this;
    if (me.currentTermIndex > 0) {
      --me.currentTermIndex;
      me.PushChanges();
      //me.sizeTerms();
    }
  }

  public swipeLeftHandler() {
    const me = this;
    if (me.currentTermIndex < me.impressumTermViewModel.length - 1) {
      ++me.currentTermIndex;
      me.PushChanges();
      //me.sizeTerms();
    }
  }

  public navigateBack() {
    this._routerHelperService.navigateBackSimple();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.impressumChangesSubscriber) {
      me.impressumChangesSubscriber.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.termChangesSubscriber) {
      me.termChangesSubscriber.unsubscribe();
    }
    if (me.routeParamSubscriber) {
      me.routeParamSubscriber.unsubscribe();
    }
    if (me.resizeSubscription) {
      me.resizeSubscription.unsubscribe();
    }
  }
}
